import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Work Who',
  basePath: '/work-who',
  columns: [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'default_for', label: 'Default for', sortable: true },
  ],
  fields: [
    { key: 'name', label: 'Name', type: 'text', required: true },
    { key: 'default_for', label: 'Default for', type: 'text' },
  ],
  defaultSort: { field: 'default_for', dir: 'asc' },
});
